import adminAxios from "@/shared/api/adminAxiosInstance";

// Получить всех сотрудников
export const getEmployees = (params) => {
    return adminAxios.get('/admin/employee', { params });
};
// Получить одного сотрудника по ID
export const getEmployeeById = (id) => {
    return adminAxios.get(`/admin/employee/${id}`);
};

export const getActiveEmployee = () => {
    return adminAxios.get('/admin/employee?isActive=true');
}

// Создать нового сотрудника
export const createEmployee = (data) => {
    return adminAxios.post('/admin/employee', data);
};

// Обновить сотрудника
export const updateEmployee = (id, data) => {
    return adminAxios.put(`/admin/employee/${id}`, data);
};

// Удалить сотрудника
export const deleteEmployee = (id) => {
    return adminAxios.delete(`/admin/employee/${id}`);
};

// получение текущего админа
export const getCurEmployee = () => {
    return adminAxios.get('/admin/employee/current')
}
// Получить список систем (для чекбоксов мастера)
export const getAdminGameSystems = (params) => {
  // можно передавать isActive=true и т.п., если бэк поддерживает
  return adminAxios.get('/admin/game-systems', { params });
};